import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';
import {
    type PrerenderedCheckoutParams,
    updatePrerenderedCheckoutParams,
    getPrerenderedCheckoutState,
} from './prerenderedCheckoutStore';
import { redirectToPrerenderedCheckout } from './redirectToPrerenderedCheckout';

export type UsePrerenderedCheckoutParams = {
    hideParentPage: () => void;
    itemId: string;
    params: PrerenderedCheckoutParams;
};

export const usePrerenderedCheckout = ({
    hideParentPage,
    itemId,
    params,
}: UsePrerenderedCheckoutParams): {
    redirect: () => void;
} => {
    const ref = useRef<PrerenderedCheckoutParams>({});

    useEffect(() => {
        if (!isEqual(ref.current, params)) {
            ref.current = params;
            updatePrerenderedCheckoutParams(params);
        }
    });

    return {
        redirect: () =>
            redirectToPrerenderedCheckout({
                itemId,
                hideParentPage,
                params: {
                    ...getPrerenderedCheckoutState().params,
                    triggerType:
                        ref.current?.triggerType ||
                        getPrerenderedCheckoutState().params?.triggerType,
                },
                isUserComesFromEmail: false,
            }),
    };
};
